export enum NetSheetStateEnum {
  AZ = 'AZ',
  CA = 'CA',
  HI = 'HI',
  NM = 'NM',
  NV = 'NV',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  TX = 'TX',
  UT = 'UT',
  WA = 'WA'
}

export enum NetSheetPartyTypeEnum {
  Borrower = 'L',
  Buyer = 'B',
  Seller = 'S'
}

export enum NetSheetPartyLabelEnum {
  B = 'Buyer',
  L = 'Borrower',
  S = 'Seller'
}

export enum NetSheetTermEnum {
  Annually = 'Annually',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  SemiAnnually = 'Semi-Annually'
}

export enum NetSheetMiscItemTypeEnum {
  Credit = 'Credit',
  Debit = 'Debit'
}

export enum NetSheetClientEnum {
  Ortouch = 'ortouch',
  Redshed = 'redshed'
}

export enum NetSheetSplitOptionsEnum {
  Seller,
  Buyer,
  Split
}
